import './Main.css';
import Home from './components/Home/Home';
import Sponsors from './components/Sponsors/Sponsors';
import AboutUs from './components/AboutUs/AboutUs';
// const TestItNow = lazy(() => import('./components/TestItNow/TestItNow'));
import OurTeam from './components/OurTeam/OurTeam';
// const Features = lazy(() => import('./components/Features/Features'));
import GetStarted from './components/GetStarted/GetStarted';
import Footer from './components/Footer/Footer';
import Copyright from './components/Copyright/Copyright';
import Navbar from './components/Navbar/Navbar';
import HowItWorks from './components/HowItWorks/HowItWorks';
import CalendarIntegration from './components/CalendarIntegration/CalendarIntegration';
// const Pricing = lazy(() => import('./components/Pricing/Pricing'));
import Faq from './components/Faq/Faq';
import ArtificialIntelligence from './components/ArtificialIntelligence/ArtificialIntelligence';
// const AIPricing = lazy(() => import('./components/AIPricing/AIPricing'));
import AdditionalServices from './components/AdditionalServices/AdditionalServices';

function Main() {
  return (
    <>
      <Navbar />
      <Home />
      <Sponsors />
      <AboutUs />
      {/* <TestItNow /> */}
      <HowItWorks />
      <CalendarIntegration />
      <OurTeam />
      {/* <Pricing /> */}
      <ArtificialIntelligence />
      <Faq />
      {/* <AIPricing /> */}
      <AdditionalServices />
      <GetStarted />
      <Footer />
      <Copyright />
    </>
  );
}

export default Main;
